/*
 * DORTI: free picks only ship with an order. See snippets/dorti-free-gate.liquid.
 *
 * "Free only" means every line in the cart has an original price of $0 (the
 * free Signature sample, the Mystery Pick). Then the checkout fieldset in the
 * drawer and on the cart page is disabled, a note says why, and any checkout
 * attempt the disabled state misses is turned away. The cart is asked again
 * after every change the theme announces.
 */
(() => {
  if (window.__dortiFreeGate) return;
  window.__dortiFreeGate = true;

  const MESSAGE = 'Free picks only ship with an order. Add something to your bag to check out.';
  let freeOnly = window.DORTI_FREE_ONLY === true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const onlyFree = (cart) =>
    !!cart && cart.item_count > 0 && cart.items.every((item) => Number(item.original_price) === 0);

  function paint() {
    document.querySelectorAll('[data-cart-checkout-buttons]').forEach((box) => {
      const fieldset = box.querySelector('[data-cart-checkout-button]');
      let note = box.querySelector('.dorti-free-gate');
      if (freeOnly) {
        if (!note) {
          note = document.createElement('p');
          note.className = 'dorti-free-gate';
          note.setAttribute('role', 'status');
          note.textContent = MESSAGE;
          box.prepend(note);
        }
        box.setAttribute('data-dorti-gated', '');
        if (fieldset) fieldset.disabled = true;
      } else {
        if (note) note.remove();
        if (box.hasAttribute('data-dorti-gated')) {
          box.removeAttribute('data-dorti-gated');
          if (fieldset) fieldset.disabled = false;
        }
      }
    });
  }

  function check() {
    fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .then((cart) => {
        if (!cart) return;
        freeOnly = onlyFree(cart);
        paint();
      })
      .catch(() => {});
  }

  // Shake the note so a tap on a dead button is answered, not ignored.
  function nudge() {
    paint();
    document.querySelectorAll('.dorti-free-gate').forEach((note) => {
      note.classList.remove('is-nudged');
      void note.offsetWidth;
      note.classList.add('is-nudged');
    });
  }

  /* The attempt itself. Cart checkouts only: a product page's own Buy it now
     buys that (paid) product, so it is left alone. */
  const CART_CHECKOUT = '[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart';
  document.addEventListener(
    'click',
    (event) => {
      if (!freeOnly) return;
      const hit = event.target && event.target.closest && event.target.closest(CART_CHECKOUT);
      if (!hit) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nudge();
    },
    true
  );
  document.addEventListener(
    'submit',
    (event) => {
      if (!freeOnly) return;
      const form = event.target;
      const action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if ((event.submitter && event.submitter.name === 'checkout') || /\/checkout/.test(action)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        nudge();
      }
    },
    true
  );

  document.addEventListener('theme:cart:change', () => setTimeout(check, 30));
  document.addEventListener('theme:cart:refresh', () => setTimeout(check, 400));

  const start = () => {
    paint();
    check();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
